import { createTheme } from '@mui/material';
import card from './card.theme';
import button from './button.theme';
import fonts from '../assets/fonts';

const theme = createTheme({
  typography: {
    fontFamily: 'DroulersClarendon-Line, sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        ${fonts}
        html {
          height: 100%;
        }
        body {
          margin: 0;
          max-height: 100%;
          scrollbar-width: thin;
          overflow-x: hidden;
          background: #F9423A;
          background-attachment: fixed;
        }
        #root {
          height: 100%;
          white-space: pre-line;
        }
      `,
    },
  },
  ...card,
  ...button
});

export default theme;